import { render, staticRenderFns } from "./edit-student.vue?vue&type=template&id=361d8ece&"
import script from "./edit-student.vue?vue&type=script&lang=js&"
export * from "./edit-student.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports